var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12V2.65625H4.5V12H11.5ZM9.34375 14V13.3438H6.65625V14H9.34375ZM10.6562 0.65625C11.1979 0.65625 11.6667 0.854167 12.0625 1.25C12.4583 1.64583 12.6562 2.11458 12.6562 2.65625V13.3438C12.6562 13.8854 12.4583 14.3542 12.0625 14.75C11.6667 15.1458 11.1979 15.3438 10.6562 15.3438H5.34375C4.80208 15.3438 4.33333 15.1458 3.9375 14.75C3.54167 14.3542 3.34375 13.8854 3.34375 13.3438V2.65625C3.34375 2.11458 3.54167 1.64583 3.9375 1.25C4.33333 0.854167 4.80208 0.65625 5.34375 0.65625H10.6562Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2b966674f2b67ff10292b58fb181174f.svg";
export { ForwardRef as ReactComponent };